import { render, staticRenderFns } from "./notification-filter-settings.vue?vue&type=template&id=722f8856&"
import script from "./notification-filter-settings.vue?vue&type=script&lang=js&"
export * from "./notification-filter-settings.vue?vue&type=script&lang=js&"
import style0 from "./notification-filter-settings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports